// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__("./node_modules/@babel/polyfill/lib/index.js")))
__webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__("./node_modules/whatwg-fetch/fetch.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__("./src/javascripts/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
